<template>
	<div class="c-content-library-card__video-overlay c-modal__mask--grey" v-on:click.prevent="$emit('close-popup')" v-if="embedUrl">
		<div class="c-content-library-card__video-holder ds-layout">
			<div class="c-content-library-card__video-inner">
				<iframe ref="iframe"
						class="c-video-card__iframe"
						title=""
						:data-src="embedUrl"
						:allow="[ isVimeo ? 'autoplay; fullscreen' : 'autoplay; fullscreen; accelerometer; encrypted-media; gyroscope; picture-in-picture' ]"
						:src="embedUrl">
				</iframe>
				<DsIconButton icon-name="button-close" variant="inverted" class="c-content-library-card__video-close" @click.prevent="$emit('close-popup')"></DsIconButton>
			</div>
		</div>
	</div>
</template>
<script>
	import { DsIconButton } from '@coloplast/design-system';
	import { screenSizes } from 'shared/settings/constants';
	import { youtubeVideoUrl } from "shared/services/urlTypeService";

	export default {
		name: 'video-popup',
		components: {
			DsIconButton
		},
		props: {
			videoUrl: {
				type: String,
				required: false,
			},
		},
		emits: ['close-popup'],
		computed: {
			isVimeo() {
				return this.videoUrl.indexOf('vimeo.com') != -1;
			},
			vimeoVideoParams() {
				let params = '?autoplay=1&api=1';
				if (!window.marketingPermissions) {
					params += '&dnt=true';
				}
				return params;
			},
			embedUrl() {
				const
					embedTemplate = this.isVimeo ? 'https://player.vimeo.com/video/' : youtubeVideoUrl(),
					embedParams = this.isVimeo ? this.vimeoVideoParams : '?autoplay=1&playsinline=1&modestbranding=1';
				if (this.embedVideoId)
					return embedTemplate + this.embedVideoId + embedParams;
				else
					return null;
			},
			isDesktop() {
				return window.innerWidth >= screenSizes.DESKTOP;
			},
			embedVideoId() {
				if (this.videoUrl) {
					if (!this.isVimeo) {
						const m = /watch\?v=([^\&$]*)/.exec(this.videoUrl);
						if (m) {
							return m[1];
						}
					}
					else {
						const m = this.videoUrl.split('/');
						if (m) {
							return m[m.length - 1];
						}
					}
				}
			},
		},
		mounted() {
			document.addEventListener('keydown', (event) => {
				if (event.key == 'Escape') {
					this.$emit('close-popup');
				}
			}, false);

			let tag = document.createElement('script');
			tag.id = this.isVimeo ? 'iframe-vimeo' : 'iframe-youtube';
			tag.src = this.isVimeo ? 'https://player.vimeo.com/api/player.js' : 'https://www.youtube.com/iframe_api';
			tag.type = 'text/javascript';
			const firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		},
	}
</script>

<style lang="scss">
	@import 'multisite/styles/settings/settings';
	@import 'multisite/styles/tools/tools';

	.c-content-library-card__video-close {
		position: absolute;
		inset-block-start: -58px;
		inset-inline-end: 0;

		@media (min-width: ds-breakpoint("sm")) {
			inset-block-start: -20px;
			inset-inline-end: -20px;
		}
	}
</style>
